module.exports = __webpack_public_path__ + "static/media/js-audio.4b312b2d.jpg";